import React, { useEffect, useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import useForm, { Form } from "../../../../../hooks/useForm";
import Controls from "../../../../../components/form/controls/Controls";
import { isDisableSubmit } from "../../../utils";
import { validationTTSEventInput } from "../../../utils/validateInput";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Divider,
  Typography,
} from "@mui/material";
import { getTTSContext } from "../../../../../apis/TTS/context.api";

const initialValue = {
  id: "",
  eventNamespace: "",
  eventName: "",
  type: "success",
  ttsContextIds: [],
};

const eventTypeOption = [
  {
    id: "success",
    name: "Success",
  },
  {
    id: "error",
    name: "Error",
  },
];

function TTSEventForm(props) {
  const { addOrEdit, recordForEdit, errorsForm, eventType } = props;
  const [listContext, setListContext] = useState([]);
  const [valueAddNew, setValueAddNew] = useState(initialValue);

  // validation input permission
  const validateFLFIntentForm = (fieldValues = values) => {
    let temp = validationTTSEventInput(fieldValues, { ...errors });

    setErrors({
      ...temp,
    });

    if (fieldValues === values)
      return Object.values(temp).every((x) => x === "");
  };

  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(initialValue, true, validateFLFIntentForm);

  const onSubmit = (e) => {
    e.preventDefault();
    if (validateFLFIntentForm()) {
      addOrEdit(values, resetForm);
      setValueAddNew(initialValue);
    }
  };

  useEffect(() => {
    setErrors({
      ...errorsForm,
    });
  }, [errorsForm, setErrors]);

  useEffect(() => {
    getTTSContext({ contextType: values.type }, (result) => {
      setListContext([...result.list]);
    });
  }, [eventType, values.type]);

  useEffect(() => {
    if (recordForEdit !== null) {
      recordForEdit.ttsContextIds = recordForEdit.contexts.map(
        (context) => context.id
      );

      setValues({
        ...recordForEdit,
      });
    } else {
      setValues({
        ...valueAddNew,
      });
      setErrors({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recordForEdit]);

  const handleOnChange = (e) => {
    handleInputChange(e);

    if (!recordForEdit) {
      const { name, value, type } = e.target;
      setValueAddNew({
        ...valueAddNew,
        [name]: type === "number" ? +value : value,
      });
    }
  };

  return (
    <Form onSubmit={onSubmit}>
      <Controls.Input
        name="eventNamespace"
        value={values.eventNamespace}
        label="event name space"
        type="text"
        onChange={handleOnChange}
        error={errors.eventNamespace}
      />

      <Controls.Input
        name="eventName"
        value={values.eventName}
        label="event name"
        type="text"
        onChange={handleOnChange}
        error={errors.eventName}
      />

      <Accordion
        sx={{
          borderRadius: "4px",
          margin: "10px 0",
          padding: "3px 0px",
          background: "unset",
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography>Contexts</Typography>
        </AccordionSummary>
        <AccordionDetails
          sx={{
            height: "200px",
            overflowY: "auto",
            flexDirection: "column",
          }}
        >
          <Divider />
          <Controls.MultipleCheckbox
            name="ttsContextIds"
            label="Contexts"
            value={values.ttsContextIds}
            onChange={handleOnChange}
            options={listContext.map((context) => ({
              ...context,
              name: `${context.contextNamespace} -  ${context.contextName}`,
            }))}
          />
        </AccordionDetails>
      </Accordion>

      <Controls.Select
        name="type"
        label="Type"
        value={values.type}
        onChange={handleOnChange}
        options={eventTypeOption}
        error={errors.type}
      />

      <Controls.Button
        sx={{ width: "100%", marginTop: "10px" }}
        type="submit"
        text="Submit"
        disabled={isDisableSubmit(recordForEdit, values)}
      />
    </Form>
  );
}

export default TTSEventForm;
